var throttle = require('./throttle');
var debounce = require('./debounce');

module.exports = {
	throttle: throttle,
	debounce: debounce
};



//////////////////
// WEBPACK FOOTER
// ./~/_throttle-debounce@1.1.0@throttle-debounce/index.js
// module id = 485
// module chunks = 1